
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sync/api",
      function () {
        return require("private-next-pages/sync/api.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sync/api"])
      });
    }
  